<template>
  <v-container>
    <v-row class="mb-n6">
      <v-col>
        <p>{{ kind.approvalTitle }}</p>
      </v-col>
    </v-row>

    <v-card class="mt-6">
      <v-card-title>
        <v-text-field
          v-model="filter"
          append-icon="mdi-magnify"
          label="ຄົ້ນຫາ ຊື່ ຫຼື ເບີໂທ"
          single-line
          hide-details
          clearable
          @keyup.enter="fetchData(1)"
          @click:clear="filter = ''; fetchData(1)"
        />
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.submitter`]="{ item }">
          {{ item.submitter ? item.submitter.name : '' }}
        </template>
        <template v-slot:[`item.home_customer`]="{ item }">
          {{ homeLabel(item.home_customer) }}
        </template>
        <template v-slot:[`item.cost_by`]="{ item }">
          {{ costName(item.payload.cost_by) }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            small
            text
            color="primary"
            @click="openDetail(item)"
          >
            <v-icon
              small
              left
            >
              mdi-eye
            </v-icon>
            ກວດສອບ
          </v-btn>
        </template>
      </v-data-table>
      <Pagination
        v-if="pagination.total_pages > 1"
        :pagination="pagination"
        :offset="offset"
        @paginate="fetchData()"
      />
    </v-card>

    <v-dialog
      v-model="detailDialog"
      max-width="760px"
    >
      <v-card v-if="selected">
        <v-card-title>{{ selected.company_name }}</v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <tbody>
              <tr
                v-for="row in detailRows"
                :key="row.label"
              >
                <td class="font-weight-bold">
                  {{ row.label }}
                </td>
                <td>{{ row.value }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div
            v-if="selected.media && selected.media.length"
            class="mt-4"
          >
            <a
              v-for="img in selected.media"
              :key="img.id"
              :href="img.original_url || img.url"
              target="_blank"
            >
              <v-avatar
                class="mr-2 rounded"
                size="96px"
              >
                <img :src="img.original_url || img.url">
              </v-avatar>
            </a>
          </div>
          <v-textarea
            v-model="rejectReason"
            class="mt-4"
            label="ເຫດຜົນ (ຕ້ອງໃສ່ເມື່ອປະຕິເສດ)"
            rows="2"
            outlined
            :error-messages="rejectError"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="detailDialog = false"
          >
            ປິດ
          </v-btn>
          <v-spacer />
          <v-btn
            color="error"
            text
            :loading="loading"
            :disabled="loading"
            @click="reject()"
          >
            ປະຕິເສດ
          </v-btn>
          <v-btn
            color="success"
            :loading="loading"
            :disabled="loading"
            @click="approve()"
          >
            ອະນຸມັດ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { submissionKind, homeLabel } from './submissionKinds';
import { formatValue } from './editFields';

const DAYS = {
  mon: 'ວັນຈັນ', tru: 'ວັນອັງຄານ', wed: 'ວັນພຸດ', thu: 'ວັນພະຫັດ', fri: 'ວັນສຸກ', sat: 'ວັນເສົາ', sun: 'ວັນອາທິດ', 'call-me': 'ໂທນັດ',
};

const COSTS = {
  container: 'ຄອນເທັນເນີ',
  fix_cost: 'ທຸລະກິດເປັນຖ້ຽວ',
  chartered: 'ມອບເໝົາ',
  bag: 'ບໍລິມາດ',
  '32km': 'ຫຼັກ32',
  infect: 'ຂີ້ເຫຍື້ອຕິດເຊື້ອ',
};

export default {
  title() {
    return 'Vientiane Waste Co-Dev|Company Approval';
  },
  data() {
    return {
      items: [],
      filter: '',
      offset: 12,
      pagination: {},
      requestSeq: 0,
      vehicleTypeNames: {},
      loading: false,
      detailDialog: false,
      selected: null,
      rejectReason: '',
      rejectError: '',
    };
  },
  computed: {
    kind() {
      return submissionKind(this.$route);
    },
    headers() {
      return [
        ...(this.kind.isConversion ? [{ text: 'ສາຍບ້ານທີ່ຈະປິດ', value: 'home_customer', sortable: false }] : []),
        { text: 'ຊື່ບໍລິສັດ', value: 'company_name' },
        { text: 'ເບີໂທ', value: 'phone' },
        { text: 'ປະເພດບໍລິການ', value: 'cost_by', sortable: false },
        { text: 'ຜູ້ເພີ່ມ', value: 'submitter', sortable: false },
        { text: 'ວັນທີເພີ່ມ', value: 'created_at' },
        { text: '', value: 'action', sortable: false },
      ];
    },
    detailRows() {
      const p = this.selected ? this.selected.payload : {};
      const vehicles = (p.vehicle_types || [])
        .map((v) => `${this.vehicleTypeNames[v.id] || `#${v.id}`}: ${Number(v.price).toLocaleString()}`)
        .join(', ');
      const home = this.selected ? this.selected.home_customer : null;
      const homeRows = this.kind.isConversion && home ? [
        { label: 'ສາຍບ້ານທີ່ຈະປິດ', value: homeLabel(home) },
        { label: 'ເບີໂທສາຍບ້ານ', value: home.user ? home.user.phone : '-' },
        { label: 'ແພັກເກດສາຍບ້ານ', value: home.package ? `${home.package.name} (${Number(home.package.price).toLocaleString()})` : '-' },
      ] : [];
      return [
        ...homeRows,
        { label: 'ຜູ້ປະສານງານຂໍເພີ່ມຂໍ້ມູນ', value: this.selected ? this.selected.requester_name : '' },
        { label: 'ເບີຜູ້ປະສານງານ', value: p.coordinator_phone || '-' },
        { label: 'ພາກສ່ວນຜູ້ປະສານງານ', value: this.selected ? this.selected.requester_department : '' },
        { label: 'ເງື່ອນໄຂ', value: (this.selected && this.selected.conditions) || '-' },
        { label: 'ເບີໂທບໍລິສັດ', value: p.phone },
        { label: 'Email', value: p.email },
        // Requests sent before the form had these two open as active / collectable.
        { label: 'ສະຖານະອອກບິນ', value: p.status || 'active' },
        { label: 'ສະຖານະເກັບ', value: formatValue('can_collect', p.can_collect === undefined || p.can_collect === null ? '1' : p.can_collect) },
        { label: 'ປະເພດບໍລິການ', value: this.costName(p.cost_by) },
        { label: 'ມູນຄ່າສັນຍາ', value: p.fix_cost ? Number(p.fix_cost).toLocaleString() : '-' },
        { label: 'ລາຄາຕາມລົດ', value: vehicles || '-' },
        { label: 'ຂີ້ເຫຍື້ອຄາດໝາຍ/ອາທິດ', value: p.expect_trash || '-' },
        { label: 'ເລີ່ມວັນທີ', value: p.start_date },
        { label: 'ມື້ບໍລິການ', value: (p.favorite_dates || []).map((d) => DAYS[d] || d).join(', ') || '-' },
        { label: 'ໝາຍເຫດ', value: p.collect_description || '-' },
        { label: 'ພິກັດ', value: `${p.lat}, ${p.lng}` },
        { label: 'ຜູ້ເພີ່ມ', value: this.selected && this.selected.submitter ? this.selected.submitter.name : '' },
        { label: 'ວັນທີເພີ່ມ', value: this.selected ? this.selected.created_at : '' },
      ];
    },
  },
  watch: {
    // Same component for the new-company and conversion routes: reload when switching.
    '$route.name': function () {
      this.items = [];
      this.filter = '';
      this.pagination = {};
      this.fetchData(1);
    },
  },
  created() {
    this.fetchData();
    this.$axios.get('vehicle_type/')
      .then((res) => {
        this.vehicleTypeNames = Object.fromEntries(res.data.data.map((v) => [v.id, v.name]));
      })
      .catch(() => {});
  },
  methods: {
    homeLabel,
    costName(value) {
      return COSTS[value] || value;
    },
    fetchData(page) {
      // Ignore responses to superseded searches (the API can be slow).
      const seq = ++this.requestSeq;
      if (page) this.$set(this.pagination, 'current_page', page);
      this.$store.commit('Loading_State', true);
      this.$axios
        .get(`${this.kind.api}/pending`, {
          params: {
            page: this.pagination.current_page,
            per_page: 20,
            filter: this.filter || undefined,
          },
        })
        .then((res) => {
          if (seq !== this.requestSeq) return;
          this.items = res.data.data.data;
          this.pagination = res.data.data.pagination;
        })
        .finally(() => {
          this.$store.commit('Loading_State', false);
        });
    },
    openDetail(item) {
      this.selected = item;
      this.rejectReason = '';
      this.rejectError = '';
      this.detailDialog = true;
    },
    approve() {
      this.review(`${this.kind.api}/${this.selected.id}/approve`, {});
    },
    reject() {
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.rejectError = 'ກະລຸນາໃສ່ເຫດຜົນທີ່ປະຕິເສດ';
        return;
      }
      this.review(`${this.kind.api}/${this.selected.id}/reject`, { reason: this.rejectReason.trim() });
    },
    review(url, body) {
      this.loading = true;
      this.$axios
        .post(url, body)
        .then((res) => {
          this.$store.commit('Toast_State', { value: true, color: 'success', msg: res.data.message });
          this.detailDialog = false;
          this.fetchData();
        })
        .catch((error) => {
          const data = (error.response && error.response.data) || {};
          // 422 from approve: phone/name/location taken since it was submitted.
          const details = data.errors ? Object.values(data.errors).map((m) => (Array.isArray(m) ? m[0] : m)).join(' ') : '';
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg: [data.message || 'Something went wrong', details].filter(Boolean).join(' — '),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
